import React, { useEffect, useState } from 'react'
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
	TwitterShareButton,
	TwitterIcon,
	LineShareButton,
	LineIcon
} from 'react-share';

const SocialShares=()=> {
	const [title, setTitle] = useState("タワーレコード渋谷");
	useEffect(()=> {
		setTimeout(()=> setTitle(document.title), 1000);
	}, [])

	const page = window.location.href;

  return (
    <div className="fixed_social_shares">
			<FacebookShareButton url={page} quote={title}>
				<FacebookIcon size={28} />
			</FacebookShareButton>
			<TwitterShareButton url={page} title={title}>
				<TwitterIcon size={28} />
			</TwitterShareButton>
			<LineShareButton url={page} title={title}>
				<LineIcon size={28} />
			</LineShareButton>
			<WhatsappShareButton url={page} title={title}>
				<WhatsappIcon size={28} />
			</WhatsappShareButton>
			</div>
  )
}

export default SocialShares;
